import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoLoadPanelComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import {AppointmentComplianceGridViewDto} from '@services';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../../../common/grid-page.component';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { EditComplianceFormComponent } from './edit-compliance-form/edit-compliance-form.component';

@Component({
    selector: 'app-appointment-compliance',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxoLoadPanelComponent,
        DxoToolbarComponent,
        DxiButtonComponent,
        UserAvatarEmailComponent,
        EditComplianceFormComponent,
    ],
    templateUrl: './appointment-compliance.component.html',
})
export class AppointmentComplianceComponent
    extends GridPageComponent<AppointmentComplianceGridViewDto>
    implements OnChanges
{
    @Input() appointmentNumber: string | null = null;
    @Input() showEditButton: boolean = false;

    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;
    isEditCompliancePopupOpened = false;
    isComplianceReadOnly = false;
    dataSource = this.dataSources.appointmentCompliances();

    lastModifiedByFilter = this.userNameOrEmailFilter('lastModifiedBy');

    protected override filterConfig: FilterConfig[] = [
        { field: 'score', op: 'contains' },
        { field: 'percentage', op: 'contains' },
        {
            field: 'lastModifiedBy.name',
            op: 'contains',
            customFilter: this.lastModifiedByFilter,
        },
        { field: 'lastModified', op: '>=' },
    ];

    constructor() {
        super();
        this.init(AppointmentComplianceGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appointmentNumber']) {
            this.dataSource = this.dataSources.appointmentCompliances(
                this.appointmentNumber,
            );
        }
    }

    override onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        this.isEditCompliancePopupOpened = true;
    }

    protected async onSave() {
        await this.dataGrid.instance.refresh();
    }

    override onEdit = (e: any) => {
        this.isEditCompliancePopupOpened = true;
        this.isComplianceReadOnly = false;
    };

    override onView = (e: any) => {
        this.isEditCompliancePopupOpened = true;
        this.isComplianceReadOnly = true;
    };
}
